@if (!error && imageUrl()) {
  <img alt="avatar" height="35" width="35" [ngSrc]="imageUrl()" (error)="error.set(true)" />
} @else {
  <div class="tt-avatar_placeholder">
    {{ placeholder() }}
  </div>
}
